const baseVariants = {
    primary: {
        color: 'primaryButtonText',
        bg: 'primaryButtonColor',
        _hover: {
            bg: 'buttonHoverColor',
            _disabled: {bg: 'buttonHoverColor', color: 'primaryButtonDisabledText'}
        },
        _disabled: {bg: 'buttonHoverColor', color: 'primaryButtonDisabledText'},
        _active: {bg: 'buttonHoverColor', textDecoration: 'none'}
    },
    secondary: {
        bgColor: 'black',
        color: 'white',
        fontStyle: 'extrabold',
        _hover: {
            bgColor: '#37383D'
        },
        _focus: {
            borderColor: '#FAB818'
        },
        _disabled: {
            bg: '#CED0D5 !important',
            opacity: 1
        }
    },
    outline: {
        color: 'outlineButtonText',
        bg: 'transparent',
        borderColor: 'outlineButtonColor',
        borderStyle: 'solid',
        borderWidth: '2px',
        _hover: {bg: 'transparent', borderColor: '#FF640A'},
        _active: {bg: 'transparent', borderColor: '#FF640A'}
    }
}
export default {
    baseStyle: {
        border: '0',
        fontWeight: 'bold',
        height: '11',
        borderRadius: '33px',
        _hover: {
            textDecoration: 'none'
        },
        '_active, _focus': {
            outline: '2px solid',
            outlineColor: 'buttonActiveOutlineColor',
            outlineOffset: '0',
            textDecoration: 'none'
        },
        _disabled: {
            opacity: 0.65
        }
    },
    variants: {
        primary: baseVariants.primary,
        secondary: baseVariants.secondary,
        outline: baseVariants.outline,

        // Full-width variants (importing from base variants)
        primaryFull: {
            ...baseVariants.primary,
            width: '100%'
        },
        secondaryFull: {
            ...baseVariants.secondary,
            width: '100%'
        },
        outlineFull: {
            ...baseVariants.outline,
            width: '100%'
        },
        apply: {
            color: 'textColorInvert',
            bg: 'buttonHoverColor',
            fontStyle: 'normal',
            fontSize: {base: 'xs', md: '16px'},
            fontWeight: '800',
            letterSpacing: 'wide',
            _hover: {bg: 'buttonHoverColor', color: 'textColorInvert', textDecoration: 'none'}
        },
        cancelReset: {
            color: 'buttonHoverColor',
            bg: 'transparent',
            fontStyle: 'normal',
            fontSize: {base: 'xs', md: '16px'},
            fontWeight: '800',
            letterSpacing: 'wide',
            _hover: {bg: 'transparent', color: 'buttonHoverColor', textDecoration: 'none'},
            borderColor: 'buttonHoverColor',
            borderStyle: 'solid',
            borderWidth: '1px'
        },
        'buy-now': {
            color: 'white',
            bg: '#fb641b',
            fontStyle: 'normal',
            fontSize: {base: 'xs'},
            letterSpacing: 'wide',
            _hover: {bg: '#fb641b', color: 'white', textDecoration: 'none'},
            _active: {bg: '#fb641b', color: 'white', textDecoration: 'none'},
            borderColor: 'buttonColor',
            borderStyle: 'solid',
            borderWidth: '1px'
        },
        solid: (props) => {
            if (props.colorScheme === 'blue') {
                return {
                    backgroundColor: 'primaryButtonColor',
                    color: 'white',
                    _hover: {
                        bg: 'buttonHoverColor',
                        textDecoration: 'none',
                        _disabled: {bg: 'buttonHoverColor'}
                    },
                    _active: {bg: 'buttonHoverColor', textDecoration: 'none'}
                }
            }
            if (props.colorScheme === 'yellow') {
                return {
                    backgroundColor: 'primaryButtonColor',
                    color: 'white',
                    _hover: {
                        bg: 'buttonHoverColor',
                        textDecoration: 'none',
                        _disabled: {bg: 'gray.500'}
                    },
                    _active: {bg: 'primaryButtonColor', textDecoration: 'none'}
                }
            }
            return {}
        },
        footer: {
            fontSize: 'sm',
            backgroundColor: 'gray.100',
            color: 'black',
            _hover: {bg: 'gray.200'},
            _active: {bg: 'gray.300'},
            paddingLeft: 3,
            paddingRight: 3
        },
        link: (props) => ({
            color: props.colorScheme === 'red' ? 'red.500' : 'primaryButtonColor',
            fontWeight: 'normal',
            minWidth: '1em',
            lineHeight: 4,
            textTransform: 'none'
        }),
        cartLink: {
            fontSize: '14px',
            lineHeight: '16px',
            color: '#4a4e58',
            textDecoration: 'underline',
            textUnderlineOffset: '3px',
            textTransform: 'none',
            margin: 0,
            marginRight: '24px',
            display: 'inline',
            background: 'none',
            fontWeight: '800',
            cursor: 'pointer',
            _hover: {
                background: 'none',
                textDecoration: 'underline !important'
            }
        },
        'menu-link': {
            color: 'black',
            justifyContent: 'flex-start',
            fontSize: 'sm',
            _hover: {
                bg: 'gray.50'
            },
            _activeLink: {
                bg: 'gray.50',
                borderLeft: 'solid',
                borderLeftColor: 'gray.600',
                borderLeftWidth: '4px'
            }
        },
        'menu-link-mobile': {
            color: 'black',
            justifyContent: 'flex-start',
            fontSize: 'sm',
            _hover: {
                bg: 'gray.50'
            },
            _activeLink: {
                bg: 'gray.50',
                borderLeft: 'solid',
                borderLeftColor: 'gray.300',
                borderLeftWidth: '4px'
            }
        },
        'search-link': {
            color: 'black',
            justifyContent: 'flex-start',
            fontSize: 'sm',
            _hover: {textDecoration: 'none'}
        },
        'bsin-notify': {
            color: 'primaryButtonText',
            bg: 'primaryButtonColor',
            fontStyle: 'normal',
            fontSize: {base: 'xs', md: '16px'},
            fontWeight: '800',
            letterSpacing: 'wide',
            _hover: {
                bg: '#ffd980',
                textDecoration: 'none',
                _disabled: {bg: 'buttonHoverColor'}
            },
            _active: {bg: 'buttonHoverColor', textDecoration: 'none'}
        },
        'remove-bsin-notify': {
            color: 'textColorInvert',
            bg: 'buttonHoverColor',
            fontStyle: 'normal',
            fontSize: {base: 'xs', md: '16px'},
            fontWeight: '800',
            letterSpacing: 'wide',
            _hover: {
                bg: '#59595b',
                textDecoration: 'none',
                _disabled: {bg: 'buttonHoverColor'}
            },
            _active: {bg: 'buttonHoverColor', textDecoration: 'none'}
        },
        'subscribe-to-series': {
            color: 'textColorInvert',
            bg: 'lightBlue',
            fontStyle: 'normal',
            fontSize: {base: 'xs', md: '16px'},
            fontWeight: '800',
            letterSpacing: 'wide',
            _hover: {
                bg: 'buttonHoverColor',
                textDecoration: 'none',
                _disabled: {bg: 'buttonHoverColor'}
            },
            _active: {bg: 'buttonHoverColor', textDecoration: 'none'}
        },
        'unsubscribe-to-series': {
            color: 'lightBlue',
            fontStyle: 'normal',
            fontSize: {base: 'xs', md: '16px'},
            fontWeight: '800',
            letterSpacing: 'wide',
            border: '2px solid',
            borderColor: 'lightBlue'
        }
    },
    sizes: {
        md: {
            height: [8, 12],
            minWidth: 11
        }
    },
    defaultProps: {
        colorScheme: 'blue'
    }
}
